<!--
 * @Description: 冷库流量排行看板
 * @Author: lufenggang
 * @LastEditors: lufenggang
 * @Date: 2020-12-02 09:52:01
 * @LastEditTime: 2020-12-02 09:52:33
-->
<template>
  <div class="board-layout">
    <zhengzhou></zhengzhou>
  </div>
</template>

<script>
import zhengzhou from "./zhengzhouTemp";
export default {
  components: {
    zhengzhou
  }
};
</script>
<style lang="scss" scoped>
.board-layout {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.app-wrapper {
  .e6-header-section {
    display: none;
  }
  .e6-container-section {
    height: calc(100vh) !important;
  }
}
</style>
